var _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7, _g3, _path8, _path9, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanner4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3887 0C6.93257 0 0.888672 4.6221 0.888672 10.327C0.888672 14.039 3.44796 17.2922 7.292 19.1124C7.00905 20.1311 6.26981 22.8071 6.12196 23.3794C5.93843 24.0897 6.38962 24.0798 6.68786 23.8899C6.91983 23.7395 10.3866 21.458 11.8829 20.4739C12.6961 20.5898 13.5322 20.6515 14.3887 20.6515C21.8448 20.6515 27.8887 16.0294 27.8887 10.327C27.8887 4.62457 21.8448 0 14.3887 0Z",
    fill: "#371C1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91014 8.42276H6.27891C6.27891 8.42276 6.28645 12.115 6.27891 12.9758C6.27891 13.6047 7.70294 13.6121 7.70043 12.9857L7.70545 8.47209C7.70545 8.47209 8.16506 8.47455 9.06669 8.47455C9.9181 8.47455 9.9181 7.15994 9.06669 7.15994C8.1073 7.15994 4.9026 7.13281 4.9026 7.13281C4.09892 7.13281 4.10143 8.42276 4.9026 8.42276",
    fill: "#F9E000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_490_1666",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 7,
    width: 6,
    height: 7
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91014 8.42276H6.27891C6.27891 8.42276 6.28645 12.115 6.27891 12.9758C6.27891 13.6047 7.70294 13.6121 7.70043 12.9857L7.70545 8.47209C7.70545 8.47209 8.16506 8.47455 9.06669 8.47455C9.9181 8.47455 9.9181 7.15994 9.06669 7.15994C8.1073 7.15994 4.9026 7.13281 4.9026 7.13281C4.09892 7.13281 4.10143 8.42276 4.9026 8.42276",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_490_1666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.92213 7.13477H4.10547V13.6141H9.92213V7.13477Z",
    fill: "#F9E000"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4632 8.66222L12.2242 11.0053H10.6369L11.4632 8.66222ZM10.6093 7.56465C10.2728 8.29225 9.05467 11.7329 8.65283 12.6455C8.36149 13.304 9.61976 13.8417 9.9111 13.1832L10.1849 12.2435H12.6888C12.6888 12.2435 12.6034 12.2829 12.935 13.1437C13.2037 13.8417 14.5047 13.3583 14.2359 12.6603C13.8517 11.6639 12.5206 8.07274 12.2769 7.56465C12.1664 7.33034 11.7646 7.16016 11.3753 7.16016C11.0538 7.16016 10.7399 7.27608 10.6068 7.56465",
    fill: "#F9E000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_490_1666",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 7,
    height: 7
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4642 8.66222L12.2252 11.0053H10.6379L11.4642 8.66222ZM10.6103 7.56465C10.2737 8.29225 9.05565 11.7329 8.65381 12.6455C8.36247 13.304 9.62074 13.8417 9.91207 13.1832L10.1858 12.2435H12.6898C12.6898 12.2435 12.6044 12.2829 12.9359 13.1437C13.2047 13.8417 14.5056 13.3583 14.2369 12.6603C13.8526 11.6639 12.5215 8.07274 12.2779 7.56465C12.1674 7.33034 11.7656 7.16016 11.3763 7.16016C11.0548 7.16016 10.7409 7.27608 10.6078 7.56465",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_490_1666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5066 7.16211H8.3584V13.8462H14.5066V7.16211Z",
    fill: "#F9E000"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7178 7.77923C14.7178 8.94832 14.7253 12.717 14.7253 12.717C14.7253 12.717 14.6148 13.4668 15.2703 13.4668C15.9258 13.4668 17.375 13.4594 18.0179 13.4594C18.6609 13.4594 18.6584 12.1152 18.0154 12.1152C17.3725 12.1152 16.1971 12.1078 16.1971 12.1078C16.1971 12.1078 16.2021 8.62275 16.1996 7.7743C16.1996 7.36487 15.8279 7.16016 15.4587 7.16016C15.0895 7.16016 14.7153 7.36734 14.7178 7.77677",
    fill: "#F9E000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_490_1666",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 7,
    width: 5,
    height: 7
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7168 7.77923C14.7168 8.94832 14.7243 12.717 14.7243 12.717C14.7243 12.717 14.6138 13.4668 15.2693 13.4668C15.9248 13.4668 17.374 13.4594 18.0169 13.4594C18.6599 13.4594 18.6574 12.1152 18.0144 12.1152C17.3715 12.1152 16.1961 12.1078 16.1961 12.1078C16.1961 12.1078 16.2011 8.62275 16.1986 7.7743C16.1986 7.36487 15.8269 7.16016 15.4577 7.16016C15.0885 7.16016 14.7143 7.36734 14.7168 7.77677",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_490_1666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6603 7.16309H14.6143V13.4673H18.6603V7.16309Z",
    fill: "#F9E000"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8311 7.59322C18.8461 8.10624 18.8135 12.7431 18.8135 13.086C18.8135 13.6286 20.2199 13.6261 20.2199 13.086C20.2199 12.457 20.2199 11.2608 20.2199 11.2608L20.6318 10.9352L22.4376 13.3524C22.8018 13.8259 23.9495 12.9701 23.5854 12.499L21.6691 10.0202C21.6691 10.0202 22.97 8.63899 23.4824 8.13831C23.7813 7.84727 22.8545 6.92975 22.5556 7.22326C22.2668 7.50443 20.2275 9.50964 20.2275 9.50964C20.2275 9.50964 20.245 8.25176 20.2275 7.55623C20.2199 7.29232 19.8909 7.16406 19.5519 7.16406C19.1902 7.16406 18.821 7.30958 18.8285 7.59322",
    fill: "#F9E000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_490_1666",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 7,
    width: 6,
    height: 7
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8301 7.59322C18.8451 8.10624 18.8125 12.7431 18.8125 13.086C18.8125 13.6286 20.2189 13.6261 20.2189 13.086C20.2189 12.457 20.2189 11.2608 20.2189 11.2608L20.6308 10.9352L22.4366 13.3524C22.8008 13.8259 23.9485 12.9701 23.5844 12.499L21.6681 10.0202C21.6681 10.0202 22.9691 8.63899 23.4814 8.13831C23.7803 7.84727 22.8535 6.92975 22.5547 7.22326C22.2658 7.50443 20.2265 9.50964 20.2265 9.50964C20.2265 9.50964 20.2441 8.25176 20.2265 7.55623C20.2189 7.29232 19.8899 7.16406 19.5509 7.16406C19.1892 7.16406 18.82 7.30958 18.8276 7.59322",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_490_1666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9485 6.93164H18.8125V13.8278H23.9485V6.93164Z",
    fill: "#F9E000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner4);
export default __webpack_public_path__ + "static/media/banner4.159e27d864cbec9e3443a81d8a509a2e.svg";
export { ForwardRef as ReactComponent };